import React from 'react'
import i18n from '../../i18n/i18n';
import { withTranslation } from 'react-i18next';
// CSS
import './footer.css'
// Image
import logo from "../../assets/Calici_Logo.png"

class Footer extends React.Component{
  render(){
    // i18n
    const footerAddress1 = i18n.t('footer-address1');
    const footerAddress2 = i18n.t('footer-address2');
    const footerAddress3 = i18n.t('footer-address3');
    const footerAddress4 = i18n.t('footer-address4');
    const footerCall1    = i18n.t('footer-call1');

    return(
      <footer className="footer">
        <div className='ft-left'>
          <img src={logo} alt='logo'/>
          <div className='ft-desc'>
            <p>{footerAddress1}</p>
            <p>{footerAddress2}</p>
            <p>{footerAddress3}</p>
            <p>{footerAddress4}</p>
          </div>
        </div>
        <div className='ft-right'>
          <p className='ft-num'>{footerCall1}</p>
          <p>COPYRIGHT ⓒ Calici  l  Design and developed by Calici</p>
        </div>
      </footer>
    )
  }
}

export default withTranslation('footer')(Footer);